import Dialog from "@mui/material/Dialog";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import BoltIcon from "@mui/icons-material/Bolt";

import { useAppDispatch } from "../../../store/hook";
import { setMyProfileProps } from "../../../store/modules/meSlice";

const dialogPaperStyle = {
  display: "flex",
  flexDirection: "column",
  borderRadius: "16px",
  width: "500px",
  maxWidth: { lg: "unset", xs: "90%" },
  padding: { lg: "40px", xs: "24px" },
};

interface ElectricityPlanDialogProps {
  open: boolean;
  viewCount?: number;
}

export const ElectricityPlanDialog = ({ open, viewCount = 1 }: ElectricityPlanDialogProps) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setMyProfileProps({ showPopup: null }));
  };

  const handleSignUp = () => {
    window.open("https://plans.gofreedompower.com/signup", "_blank")?.focus();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: dialogPaperStyle }}
    >
      <Stack
        sx={{
          alignItems: "center",
          textAlign: "center",
          gap: "20px",
        }}
      >
        <Box
          sx={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor: "primary.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <BoltIcon sx={{ fontSize: "40px", color: "primary.main" }} />
        </Box>

        <Typography
          sx={{
            fontSize: { lg: "28px", xs: "22px" },
            lineHeight: { lg: "34px", xs: "28px" },
            fontWeight: 700,
            color: "text.primary",
          }}
        >
          Welcome to myFreedom!
        </Typography>

        <Typography
          sx={{
            fontSize: { lg: "16px", xs: "14px" },
            lineHeight: { lg: "24px", xs: "20px" },
            color: "text.secondary",
            maxWidth: "380px",
          }}
        >
          Have you switched your electricity plan over to our new solar buyback program?
        </Typography>

        <Button
          variant="contained"
          sx={{
            marginTop: "10px",
            borderRadius: "100px",
            width: { lg: "200px", xs: "100%" },
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: 600,
          }}
          onClick={handleSignUp}
        >
          Sign Up Now
        </Button>

        <Typography
          sx={{
            fontSize: "12px",
            lineHeight: "16px",
            color: "text.disabled",
          }}
        >
          Clicking Sign Up Now will open our electricity plans page in a new tab
        </Typography>
      </Stack>

      <IconButton
        color="inherit"
        size="small"
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: { lg: "10px", xs: "5px" },
          right: { lg: "10px", xs: "5px" },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Dialog>
  );
};
